export const gettersCustomFields = {
    hasUnfilledCustomFields(state) {
        return state.hasUnfilledCustomFields
    },
}
